var map = {
	"./1.png": 890,
	"./10.png": 1050,
	"./11.png": 1051,
	"./12.png": 1052,
	"./13.png": 1053,
	"./14.jpg": 1054,
	"./2.png": 1055,
	"./3.png": 1056,
	"./4.png": 1057,
	"./5.png": 1058,
	"./6.png": 1059,
	"./7.png": 1060,
	"./8.png": 1061,
	"./9.jpg": 1062,
	"./cover/1.png": 1063,
	"./cover/10.png": 1064,
	"./cover/11.png": 1065,
	"./cover/12.png": 1066,
	"./cover/13.png": 1067,
	"./cover/14.png": 1068,
	"./cover/15.png": 1069,
	"./cover/2.png": 1070,
	"./cover/3.png": 1071,
	"./cover/4.png": 1072,
	"./cover/5.png": 1073,
	"./cover/6.png": 1074,
	"./cover/7.png": 1075,
	"./cover/8.png": 1076,
	"./cover/9.png": 1077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1218;